import { Component, OnInit } from '@angular/core';
import { SolicitudIntermediarioService } from '../../Service/solicitudIntermediario.service';
import { ParametrosService } from '../../../services/parametros.service';
import { Departamento } from '../../../comun/models/departamento';
import { Ciudad } from '../../../comun/models/ciudad';
import { Router } from '@angular/router';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { NeoSolicitudNegada } from '../../Model/neoSolicitudNegada';
import { NeoTiposNegacionService } from '../../../comun/services/neoTiposNegacion.service';
import { NeoTipoNegacion } from '../../../comun/models/neoTipoNegacion';
import { DataLocalStorageService } from '../../Service/dataLocalStorage.service';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { NeoTrazabilidadAuditoriaDTO } from '../../Model/neoTrazabilidadAuditoriaDTO';
import { TrazabilidadAuditoriaService } from '../../Service/trazabilidad-auditoria.service';
import { Constantes } from 'src/app/comun/data/constantes';
declare var $: any;
$(function () {
  $('[data-bs-toggle="tooltip"]').tooltip();
});

@Component({
    selector: 'app-revisar-solicitudes-if',
    templateUrl: './revisar-solicitudes-if.component.html',
    styleUrls: ['./revisar-solicitudes-if.component.scss'],
    providers: [
        SolicitudIntermediarioService,
        ParametrosService,
        NeoIntermediarioFinancieroService,
        NeoTiposNegacionService,
    ],
    standalone: false
})
export class RevisarSolicitudesIfComponent implements OnInit {
  public departamentos: Departamento[] = [];
  public ciudades: Ciudad[] = [];
  public solicitudesPendientes: any[] = [];
  public tiposNegacion: NeoTipoNegacion[] = [];
  public solicitudNegar: NeoSolicitudNegada;
  public user;
  habilitarCampos: number = 0.1;
  estados: any[] = [];
  filterForm: UntypedFormGroup;
  paginaActual: number = 1;
  totalPaginas: number = null;
  idOpcionNegacion: number;
  textNegacionObservacion: string = '';
  idTrazabilidad: number = 0;


  constructor(
    private readonly _solicitudIntermediarioService: SolicitudIntermediarioService,
    private readonly _parametrosService: ParametrosService,
    private readonly router: Router,
    private readonly _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private readonly _userIntermediarioService: UserService,
    private readonly _neoTiposNegacionService: NeoTiposNegacionService,
    private readonly _dataLocalStorageService: DataLocalStorageService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly _sweetAlert: SweetAlertService,
    private readonly _serviceTrazabilidad: TrazabilidadAuditoriaService
  ) {
    window.scroll(0, 0);
    this.user = this._userIntermediarioService.getUser();
    this.solicitudNegar = new NeoSolicitudNegada('', null, 0, null);
    this.filterForm = this.formBuilder.group({
      idCiudad: null,
      idDepartamento: null,
      idSolicitud: null,
      fechaRecepcion: null,
      idEstadoSolicitud: null,
      idCliente: this.user.idCliente,
      isFilterDesembolso: false,
      isFilterRevisar: true,
      isFilterAprobar: false,
      pagina: this.paginaActual,
      idUsuario: this.user.idUsuario
    });
  }

  ngOnInit(): void {
    this.getSolicitudes();
    this._solicitudIntermediarioService.getEstadosIntermediario(this.user.idUsuario).subscribe(
      (response) => {
        var estadosCargados;
        estadosCargados = response.estados;
        estadosCargados.forEach((estado) => {
          if (
            estado.idEstadoSolicitudIntermediario == 1 ||
            estado.idEstadoSolicitudIntermediario == 2
          )
            this.estados.push(estado);
        });
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los datos');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );

    this._parametrosService.getDepartamentos('169').subscribe(
      (response) => {
        this.departamentos = response['data'];
      },
      (error) => {
        this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar los departamentos');
      }
    );
  }

  getSolicitudes() {
    this.filterForm.get('pagina').setValue(this.paginaActual);
    this._neoIntermediarioFinancieroService
      .getFiltrarSolicitud(this.filterForm.value)
      .subscribe((data) => {
        this.solicitudesPendientes = data.data;
        this.totalPaginas = data.paginasTotales;
        return new Promise((resolve, reject) => {
          this.habilitarBotonesSolicitud();
        });
      });
  }

  changePage(i) {
    this.paginaActual = i;
    this.getSolicitudes();
  }

  habilitarBotonesSolicitud() {
    var idSolicitud = this._dataLocalStorageService.getIdSolicitudPendRevisar();
    if (idSolicitud != null) {
      this.solicitudesPendientes.forEach((element, index) => {
        if (element.numeroSolicitud == idSolicitud.toString()) {
          this.habilitarCampos = index;
          this._dataLocalStorageService.deleteIdSolicitudPendRevisar();
        }
      });
    }
  }

  getCiudades(idDepartamento) {
    if (idDepartamento != 'null') {
      this._parametrosService.getCiudades(idDepartamento).subscribe(
        (response) => {
          this.ciudades = response['data'];
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'No fue posible cargar las ciudades');
        }
      );
    } else {
      this.ciudades = [];
    }
  }

  verDetalleSolicitud(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    this._dataLocalStorageService.saveIdSolicitudPendRevisar(numeroSolicitud);
    this.router.navigate(
      [
        '/solicitud/intermediario/' + numeroSolicitud,
      ],
      { state: { from: Constantes.TRANSACCIONAL } }
    );
  }

  negarSolicitud(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    if (numeroSolicitud != '') {
      this.revisionNegacion(this.solicitudesPendientes[i].estadoSolicitud, numeroSolicitud);
      this.correccionNegacionOferta(this.solicitudesPendientes[i].estadoSolicitud, numeroSolicitud);
      this.solicitudNegar.idSolicitud = numeroSolicitud;
      this.solicitudNegar.idCliente = Number(this.user.idCliente);
      this.solicitudNegar.idUsuario = Number(this.user.idUsuario);
      this._neoTiposNegacionService.getTiposNegacionHabilitados().subscribe(
        (response) => {
          this.tiposNegacion = response;
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true,
            'No fue posible cargar los tipos de negación'
          );
        },
        () => {
          setTimeout(() => {
            $('.selectpicker').selectpicker('refresh');
            this.idOpcionNegacion = null;
            this.textNegacionObservacion = '';
          });
        }
      );
    }
  }

  verSolicitud(i) {
    var numeroSolicitud = this.solicitudesPendientes[i].numeroSolicitud;
    if (
      this.solicitudesPendientes[i].idEstadoSolicitud_NeoEstadoSolicitud == 2 ||
      this.solicitudesPendientes[i].idEstadoSolicitud_NeoEstadoSolicitud == 1
    ) {
      this.router.navigate(
        [
          '/intermediario/transaccional/revisarSolicitudes/propuestaIntermediario/' +
          numeroSolicitud,
        ],
        { state: { from: Constantes.TRANSACCIONAL } }
      );
    }
  }

  confirmarNegacionSolicitud() {
    if (
      this.solicitudNegar.id_tipo_negacion != null &&
      this.solicitudNegar.idCliente != null &&
      this.solicitudNegar.idSolicitud != ''
    ) {
      this.solicitudNegar.id_tipo_negacion = Number(
        this.solicitudNegar.id_tipo_negacion
      );
      if (this.idOpcionNegacion == 6 || this.idOpcionNegacion == 1) {
        if (this.textNegacionObservacion.length > 0) {
          this.solicitudNegar.observaciones = this.textNegacionObservacion;
          this.callServiceNegarSolicitud();
        } else {
          this._sweetAlert.infoModal('¡La observación no puede ser nula!', true);
        }
      } else {
        this.solicitudNegar.observaciones = this.textNegacionObservacion;
        this.callServiceNegarSolicitud();
      }
    } else {
      this._sweetAlert.errorModal("Error!", true,
        'No fue posible cargar los datos para la negación'
      );
    }
  }

  cancelar() {
    this.cerrarTrazabilidad(this.idTrazabilidad);
  }

  callServiceNegarSolicitud() {
    this._neoIntermediarioFinancieroService
      .negarSolicitud(this.solicitudNegar)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this._sweetAlert.successModal('Solicitud negada correctamente');
            this.solicitudNegar = new NeoSolicitudNegada('', null, 0, null, '');
            $('#negarModal').modal('hide');
            this.cerrarTrazabilidad(this.idTrazabilidad);
            this.getSolicitudes();
          } else {
            this._sweetAlert.errorModal("Error!", true, 'No fue posible negar la solicitud');
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true,
            'No fue posible negar la solicitud' +
            this.solicitudNegar.idSolicitud
          );
        }
      );
  }

  limpiarFiltro() {
    this.filterForm.get('idCiudad').setValue(null);
    this.filterForm.get('idDepartamento').setValue(null);
    this.filterForm.get('idSolicitud').setValue(null);
    this.filterForm.get('fechaRecepcion').setValue(null);
    this.filterForm.get('idEstadoSolicitud').setValue(null);
    this.filterForm.get('pagina').setValue(1);
    this.paginaActual = 1;
    this.getSolicitudes();
  }

  // Trazabilidad
  revisionNegacion(estado: string, idSolicitud: string) {
    if (estado == Constantes.PENDIENTE) {
      const body: NeoTrazabilidadAuditoriaDTO = {
        nombreSeccion: Constantes.TRANSACCIONAL,
        nombrePantalla: Constantes.NEGAR_SOLICITUD,
        idCliente: +this.user.idCliente,
        idUsuario: +this.user.idUsuario,
        idSolicitud: String(idSolicitud),
        perfil: Constantes.PERFIL_ALIADO
      }
      this._serviceTrazabilidad.generarRevisionNegacion(body).subscribe(
        {
          next: resp => {
            this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
          },
          error: err => {
          }
        });
    }

  }

  correccionNegacionOferta(estado: string, idSolicitud: string) {
    if (estado == Constantes.DEVUELTA_APROBADOR) {
      const body: NeoTrazabilidadAuditoriaDTO = {
        nombreSeccion: Constantes.TRANSACCIONAL,
        nombrePantalla: Constantes.NEGAR_OFERTA,
        idCliente: +this.user.idCliente,
        idUsuario: +this.user.idUsuario,
        idSolicitud: String(idSolicitud),
        perfil: Constantes.PERFIL_ALIADO
      }
      this._serviceTrazabilidad.generarCorreccionNegacionOferta(body).subscribe(
        {
          next: resp => {
            this.idTrazabilidad = resp.trazabilidad.idTrazabilidad;
          },
          error: err => {
          }
        });
    }

  }


  cerrarTrazabilidad(idTrazabilidad: number) {
    this._serviceTrazabilidad.cierreTrazabilidad(idTrazabilidad).subscribe({
      next: resp => {
      },
      error: err => {
      }
    });
  }
}
